import { filterName } from "../utils";

const applyServiceNowStringFilter = (
  filteredEntities,
  appliedFilters,
  filterKey,
  fieldPath
) => {
  if (
    filterKey in appliedFilters &&
    Object.keys(appliedFilters[filterKey]).length > 0
  ) {
    const checkedValues = Object.keys(appliedFilters[filterKey]).filter(
      (value) => appliedFilters[filterKey][value]
    );
    if (checkedValues.length > 0) {
      return filteredEntities.filter((entity) => {
        const value = fieldPath
          .split(".")
          .reduce(
            (acc, part) => acc && acc[part],
            entity?.servicenow_cmdb_data
          );

        if (!value) return false;

        if (typeof value === "string" && value.includes(",")) {
          const values = value.split(",").map((v) => v.trim());
          return values.some((v) => checkedValues.includes(v));
        }

        return checkedValues.includes(value);
      });
    }
  }
  return filteredEntities;
};

const applyServiceNowBooleanFilter = (
  filteredEntities,
  appliedFilters,
  filterKey,
  fieldPath
) => {
  if (
    filterKey in appliedFilters &&
    Object.keys(appliedFilters[filterKey]).length > 0
  ) {
    const checkedValues = Object.keys(appliedFilters[filterKey]).filter(
      (value) => appliedFilters[filterKey][value]
    );
    if (checkedValues.length > 0) {
      return filteredEntities.filter((entity) => {
        const value = fieldPath
          .split(".")
          .reduce(
            (acc, part) => acc && acc[part],
            entity?.servicenow_cmdb_data
          );
        if (value == null) return false;
        const valueString = value ? "true" : "false";
        return checkedValues.includes(valueString);
      });
    }
  }
  return filteredEntities;
};

export const applyServiceNowFilters = (entities, appliedFilters) => {
  let filteredEntities = [...entities];

  // String filters
  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_COMPANY,
    "company"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_RESPONSIBLE_GROUP,
    "responsible_group"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_MOST_FREQUENT_USER,
    "most_frequent_user"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_OWNING_COMPANY_SYS_ID,
    "owning_company_sys_id"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_OWNING_SERVICE_OWNING_ORGANIZATION,
    "owning_service_owning_organization"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_ENVIRONMENT,
    "environment"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_SYS_TAGS,
    "sys_tags"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_APPLICATION_ID_TAG,
    "application_id_tag"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_OWNING_SERVICE_OWNED_BY,
    "owning_service_owned_by"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_OWNING_SERVICE_USED_BY_COMPANIES,
    "owning_service_used_by_companies"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_USED_BY_COMPANIES,
    "used_by_companies"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_OWNING_SERVICE_MANAGED_BY,
    "owning_service_managed_by"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_IT_APPLICATION_OWNER,
    "it_application_owner"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_OWNING_SERVICE_ASSIGNMENT_GROUP,
    "owning_service_assignment_group"
  );

  filteredEntities = applyServiceNowStringFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_SYS_CLASS_NAME,
    "sys_class_name"
  );

  // Boolean filters
  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_CROWN_JEWEL,
    "crown_jewel"
  );

  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_IS_GLOBAL,
    "is_global"
  );

  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_PCI_CDE,
    "pci_cde"
  );

  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_PCI_SUPPORTING,
    "pci_supporting"
  );

  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_CCPA,
    "ccpa"
  );

  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_SOX,
    "sox"
  );

  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_PII,
    "pii"
  );

  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_GDPR,
    "gdpr"
  );

  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_PCI_SUPPORTING_ASSET,
    "pci_supporting_asset"
  );

  filteredEntities = applyServiceNowBooleanFilter(
    filteredEntities,
    appliedFilters,
    filterName.SERVICENOW_ISO_27001,
    "iso_27001"
  );

  entities.length = 0;
  for (let i = 0; i < filteredEntities.length; i++) {
    entities[i] = filteredEntities[i];
  }
};
